import useTenantScope from 'LearningManager/hooks/useTenantScope';

export const useAudienceTenantId = (tenantId?: number) => {
	const { canSelectTenant, globalTenantId, scopedTenant } = useTenantScope();

	const audienceTenantId =
		tenantId ??
		(canSelectTenant ? globalTenantId : Number(scopedTenant) || undefined);

	return {
		tenantId: audienceTenantId,
		isTenantResolved: canSelectTenant || Boolean(audienceTenantId)
	};
};

export default useAudienceTenantId;
